import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import '../src/Utils/Utils.css'
import './product/common/productCommon.css'
import { Helmet, HelmetProvider } from 'react-helmet-async'

ReactDOM.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>,
    document.getElementById('root'),
)

const loadGAScript = () => {
    const gaKey = process.env.REACT_APP_GOOGLE_TAG_KEY

    if (!gaKey) {
        console.warn('Google Analytics key is missing!')
        return
    }

    // Load GA script
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gaKey}`
    document.head.appendChild(script)

    // Init gtag
    window.dataLayer = window.dataLayer || []
    function gtag() {
        window.dataLayer.push(arguments)
    }
    window.gtag = gtag
    gtag('js', new Date())
    gtag('config', gaKey)
}

loadGAScript()

serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
